<!-- Step 1 -->
<div class="step-section mb-4">
  <div class="step-header mb-3">
    <div class="is-flex is-align-items-center">
      <h3
        class="title is-6 has-text-weight-semibold mb-0"
        style="color: #303032"
      >
        {{ PolicyInitiativeSteps.get(1) }}
      </h3>
    </div>
    <hr style="margin: 8px 0; border: none; height: 1px; background: #e9eeff" />
  </div>
  <div class="step-content">
    <table
      class="table is-fullwidth"
      style="
        background: transparent;
        border-collapse: separate;
        border-spacing: 0;
      "
    >
      <tbody>
        @for (item of itemsByStep().step1; track $index) {
        <ng-container
          *ngTemplateOutlet="itemContent; context: { $implicit: item }"
        ></ng-container>
        }
      </tbody>
    </table>
  </div>
</div>

<!-- Step 2 -->
@if (itemsByStep().step2.length > 0) {
<div class="step-section mb-4">
  <div class="step-header mb-3">
    <div class="is-flex is-align-items-center">
      <h3
        class="title is-6 has-text-weight-semibold mb-0"
        style="color: #303032"
      >
        {{ PolicyInitiativeSteps.get(2) }}
      </h3>
    </div>
    <hr style="margin: 8px 0; border: none; height: 1px; background: #e9eeff" />
  </div>
  <div class="step-content">
    <table
      class="table is-fullwidth"
      style="
        background: transparent;
        border-collapse: separate;
        border-spacing: 0;
      "
    >
      <tbody>
        @for (item of itemsByStep().step2; track $index) {
        <ng-container
          *ngTemplateOutlet="itemContent; context: { $implicit: item }"
        ></ng-container>
        }
      </tbody>
    </table>
  </div>
</div>
}

<!-- Step 3 -->
@if (itemsByStep().step3.length > 0) {
<div class="step-section mb-4">
  <div class="step-header mb-3">
    <div class="is-flex is-align-items-center">
      <h3
        class="title is-6 has-text-weight-semibold mb-0"
        style="color: #303032"
      >
        {{ PolicyInitiativeSteps.get(3) }}
      </h3>
    </div>
    <hr style="margin: 8px 0; border: none; height: 1px; background: #e9eeff" />
  </div>
  <div class="step-content">
    <table
      class="table is-fullwidth"
      style="
        background: transparent;
        border-collapse: separate;
        border-spacing: 0;
      "
    >
      <tbody>
        @for (item of itemsByStep().step3; track $index) {
        <ng-container
          *ngTemplateOutlet="itemContent; context: { $implicit: item }"
        ></ng-container>
        }
      </tbody>
    </table>
  </div>
</div>
}

<!-- Reusable Item Template -->
<ng-template #itemContent let-item>
  @if (item && item.value !== '' && item.value !== null && item.value !==
  undefined) {
  <tr style="border-bottom: 1px solid #f5f5f5">
    <td
      class="has-text-weight-bold is-size-7"
      style="
        color: #7e6d72;
        padding: 20px 24px 20px 0;
        vertical-align: top;
        white-space: nowrap;
        width: 200px;
        letter-spacing: 0.5px;
      "
    >
      {{ item.label }}
    </td>
    <td style="padding: 20px 0; vertical-align: top">
      @switch (item.type) { @case ('text') {
      <ng-container
        *ngTemplateOutlet="
          textView;
          context: { $implicit: item.value, multiValue: item.multiValue, key: item.key }
        "
      >
      </ng-container>
      } @case ('link') {
      <ng-container
        *ngTemplateOutlet="
          linkView;
          context: { $implicit: item.value, multiValue: item.multiValue }
        "
      >
      </ng-container>
      } @case ('files') {
      <ng-container
        *ngTemplateOutlet="
          fileView;
          context: { $implicit: item.value, multiValue: item.multiValue }
        "
      >
      </ng-container>
      } @case ('image') {
      <ng-container
        *ngTemplateOutlet="
          imageView;
          context: { $implicit: item.value, multiValue: item.multiValue }
        "
      >
      </ng-container>
      } @case ('richText') {
      <ng-container
        *ngTemplateOutlet="
          richTextView;
          context: { $implicit: item.value, multiValue: item.multiValue }
        "
      >
      </ng-container>
      } }
    </td>
  </tr>
  }
</ng-template>

<!-- Text Value Template -->
<ng-template #textView let-value let-multiValue="multiValue" let-key="key">
  @if (multiValue && value?.length) {
  <ul style="list-style: none; padding: 0; margin: 0">
    @for (text of value; track $index) {
    <li class="mb-1">
      <span class="is-size-6" style="color: #303032">{{ text }}</span>
    </li>
    }
  </ul>
  } @else if (!multiValue && value) {
  <p
    class="is-size-6 mb-0"
    [class.description-text]="key === 'description'"
    style="color: #303032"
  >{{ value | emptyPlaceHolder }}</p>
  } @else {
  <p class="is-size-6 has-text-grey">{{ '' | emptyPlaceHolder }}</p>
  }
</ng-template>

<!-- Link Value Template -->
<ng-template #linkView let-value let-multiValue="multiValue">
  @if (multiValue && value?.length) {
  <ul style="list-style: none; padding: 0; margin: 0">
    @for (url of value; track url) {
    <li class="mb-1">
      <a
        [href]="url"
        target="_blank"
        rel="noopener noreferrer"
        class="is-size-6"
        style="color: #5c1ee8; text-decoration: underline"
      >
        {{ url }}
      </a>
    </li>
    }
  </ul>
  } @else if (!multiValue && value) {
  <a
    [href]="value"
    target="_blank"
    rel="noopener noreferrer"
    class="is-size-6"
    style="color: #5c1ee8; text-decoration: underline"
  >
    {{ value | emptyPlaceHolder }}
  </a>
  } @else {
  <p class="is-size-6 has-text-grey">{{ '' | emptyPlaceHolder }}</p>
  }
</ng-template>

<!-- File Value Template -->
<ng-template #fileView let-value let-multiValue="multiValue">
  @if (value?.length && multiValue) {
  <ul style="list-style: none; padding: 0; margin: 0">
    @for (file of value; track $index) {
    <li class="mb-1">
      <a
        [href]="storagePath + '/' + file.path"
        target="_blank"
        rel="noopener noreferrer"
        class="is-size-6"
        style="color: #57b3a0; text-decoration: underline"
      >
        {{ file.name }}
      </a>
    </li>
    }
  </ul>
  } @else {
  <p class="is-size-6 has-text-grey">{{ '' | emptyPlaceHolder }}</p>
  }
</ng-template>

<!-- Image Value Template -->
<ng-template #imageView let-value let-multiValue="multiValue">
  @if (multiValue && value?.length) {
  <div style="display: flex; flex-wrap: wrap; gap: 8px">
    @for (image of value; track $index) {
    <case-image
      [path]="image"
      className="is-block"
      style="max-width: 150px; height: auto"
    >
    </case-image>
    }
  </div>
  } @else {
  <p class="is-size-6 has-text-grey">{{ '' | emptyPlaceHolder }}</p>
  }
</ng-template>

<!-- Rich Text Value Template -->
<ng-template #richTextView let-value let-multiValue="multiValue">
  @if (value?.length) {
  <div class="content" [innerHTML]="value"></div>
  } @else {
  <p class="is-size-6 has-text-grey">{{ '' | emptyPlaceHolder }}</p>
  }
</ng-template>
